<template>
<v-container grid-list-lg fluid pt-0 px-2>
    <v-alert
      :value="installPWADialog"
      transition="slide-y-transition"
      color="grey lighten-3"
      class="installPrompt my-0 px-0"
    >
    <v-layout row align-center>
      <v-flex @click="installPWADialog = false" xs1 class="flex-div justify-center">
        <v-icon class="grey--text text--darken-4">close</v-icon>
      </v-flex>
      <v-flex xs7 class="grey--text text--darken-4 pl-2">
        <h3>Ajouter à l'écran d'accueil</h3>
        <span>Profiter de votre offre comme une application</span>
      </v-flex>
      <v-flex xs4 class="flex-div justify-end">
        <v-btn @click="showInstallPromotion()" color="primary" class="mr-1">
          Ajouter
        </v-btn>
      </v-flex>
    </v-layout>
    </v-alert>
    <v-layout row wrap justify-center v-if="loaded">
      <v-flex xs12 md6 lg4>
        <!-- // container -->
        <v-layout row wrap px-2>
          <v-flex xs12>
              <v-layout mt-2 row wrap justify-center>
              <v-flex v-if="offer.consumable.target" xs5 py-0>
                <img :src="owner.logo_url" :alt="owner.name" class="w-100"/>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap align-center>
              <v-flex xs4>
                <div class="img-voucher-item">
                  <img :src="offer.consumable.target ? offer.consumable.target : owner.logo_url" alt="image"/>
                </div>
              </v-flex>
              <v-flex flex xs8>
                <h2 class="mt-3 w-100 font-weight-regular">{{ offer.consumable.message }}</h2>
                <p v-if="offer.consumable.target" class="my-0">{{offer.consumable.target.description}}</p>
              </v-flex>
            </v-layout>
            <v-layout column>
              <v-flex class="flex-div align-center info--text" icon="timer">
                <v-icon class="ml-1 mr-2" color="info">timer</v-icon>
                <span>{{offerExpireAt}}</span>
              </v-flex>
              <v-flex class="flex-div flex-column align-center pt-3 pb-2">
                <img width="80%" :src="barCode.images.barcode_svg" alt="barCode">
                <h3 class="my-1 py-0 text-xs-center">{{barCode.formatted_identifier}}</h3>
              </v-flex>
              <v-flex  class="flex-div justify-center">
                <img v-if="browserName === 'Safari'" width="40%" src="../assets/img/add-to-apple-wallet.png" alt="apple wallet">
                <v-btn outline round v-else color="primary">
                  <v-icon>picture_as_pdf</v-icon><span class="mr-auto">Télécharger</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          </v-layout>
          <!-- Boutique -->
          <v-layout row wrap class="grey lighten-3 text--grey text--darken-3 pt-2" mt-3 px-2>
            <v-flex xs12>
              <geolocate-card :nearestPos="nearestPos" :loading="fetchingPos" :geoLocation="geoLocation" @click="locateMe()" />
            </v-flex>
            <v-flex>
              <v-btn @click="showPOSList = true" large color="primary" class="w-100 flex-div mx-0">
                <span class="mr-auto">Voir tous les points de vente</span><v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <span class="grey--text mt-3 mx-2 d-block text-xs-justify">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Unde esse saepe, excepturi perferendis neque vitae molestiae sit tempore. Facilis repudiandae quis debitis odit, fugiat quod eos obcaecati illum rem blanditiis?
          </span>
      </v-flex>
    </v-layout>
    <v-layout v-else mt-4>
      <v-flex>
        <clip-loader class="my-4" :loading="!loaded" color="#78909c" width="60px" height="60px"></clip-loader>
      </v-flex>
    </v-layout>
    <point-of-sales-list v-model="showPOSList" :pos="displayedPosList" :geoLocation="geoLocation" :loading="fetchingPos" @close="showPOSList = false"></point-of-sales-list>
  </v-container>
</template>
<script>
import req from '@/packs/request.js'
import axios from 'axios'
import GeolocateCard from '@/components/GeolocateCard.vue'
import PointOfSalesList from '@/components/PointOfSalesList.vue'

export default {
  components: {
    GeolocateCard,
    PointOfSalesList
  },
  data () {
    return {
      req: null,
      showPOSList: false,
      offer: {},
      nearPos: [],
      pos: [],
      posLoaded: false,
      offerLoaded: false,
      fetchingPos: false,
      deferredPrompt: null,
      installPWADialog: false,
      geoLocation: {
        address: '',
        coords: {}
      },
      browserName: ''
    }
  },
  computed: {
    offerExpireAt () {
      return (this.offer.expire_at) ? `L'offre expire le ${this.offer.expire_at}` : 'Cette offre est permanente'
    },
    externalGeolocation () {
      return (this.$route.query.lat && this.$route.query.lon)
    },
    displayedPosList () {
      return (this.nearPos.length > 0) ? this.nearPos : this.pos
    },
    nearestPos () {
      return this.nearPos[0]
    },
    barCode () {
      return this.offer.identifiers[0]
    },
    loaded () {
      return (this.offerLoaded && this.owner)
    },
    owner () {
      return this.$store.state.owner
    }
  },
  created () {
    // PWA Install Prompt
    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault()
      this.deferredPrompt = e
      this.installPWADialog = true
      // eslint-disable-next-line no-console
      console.log('beforeinstallprompt passed!')
    })

    this.req = axios.create({
      baseURL: req.base_url,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `ApiKey ${this.$route.params.apiKey}`
      }
    })

    // Need to be moved in App.vue then save in store.
    this.browserName = this.getBrowserName()

    if (this.$route.params.offerId && this.$route.params.apiKey) {
      this.fetchOffer()
      this.fetchPointOfSales()

      if (this.externalGeolocation) this.locateMe(this.$route.query.lat, this.$route.query.lon)
    }
  },
  methods: {
    showInstallPromotion () {
      this.deferredPrompt.prompt()
      this.installPWADialog = false
    },
    async fetchOffer () {
      let res = await this.req.get(`/pass/offers/${this.$route.params.offerId}`)
      this.offer = res.data
      this.offerLoaded = true
    },
    async locateMe (lat = null, lon = null) {
      this.fetchingPos = true

      if (!lat || !lon) {
        this.geoLocation = await this.getGeoLocation()
      } else {
        this.geoLocation.coords.latitude = lat
        this.geoLocation.coords.longitude = lon
      }

      await this.fetchMyAdress()
      this.fetchNearPointOfSales()
    },
    async fetchMyAdress () {
      const lat = this.geoLocation.coords.latitude
      const lon = this.geoLocation.coords.longitude

      const res = await this.req.get(`/pass/geolocate_me?latitude=${lat}&longitude=${lon}`)
      this.geoLocation.address = res.data.address.split(',')[0]
    },
    async fetchPointOfSales () {
      const res = await this.req.get(`/pass/offers/${this.$route.params.offerId}/point_of_sales`)
      this.pos = res.data
      this.posLoaded = true
    },
    async fetchNearPointOfSales () {
      const lat = this.geoLocation.coords.latitude
      const lon = this.geoLocation.coords.longitude
      const offerId = this.$route.params.offerId

      let res = await this.req.get(`/pass/offers/${offerId}/point_of_sales/nearest?latitude=${lat}&longitude=${lon}&quantity=10&max_radius=1000`)
      this.nearPos = res.data
      this.fetchingPos = false
    },
    async getGeoLocation () {
      return new Promise((resolve, reject) => {
        if (!('geolocation' in navigator)) {
          reject(new Error('Geolocation is not available.'))
        }
        navigator.geolocation.getCurrentPosition(pos => {
          resolve(pos)
        }, err => {
          reject(err)
        })
      })
    },
    /* eslint-disable */
    getBrowserName () {
      // Opera 8.0+
      const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0
      // Firefox 1.0+
      const isFirefox = typeof InstallTrigger !== 'undefined'
      // Safari 3.0+ "[object HTMLElementConstructor]"
      const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]' })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))
      // Edge 20+
      const isEdge = !!window.StyleMedia
      // Chrome 1 - 71
      const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)

      return isOpera ? 'Opera'
        : isFirefox ? 'Firefox'
          : isSafari ? 'Safari'
            : isEdge ? 'Edge'
              : isChrome ? 'Chrome'
                : 'Dont know'
    }
    /* eslint-enable */
  }
}
</script>

<style lang="css" scoped>
  .installPrompt {
    max-width: 100%;
  }
</style>
